var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0C186.274 0 240 53.7258 240 120C240 186.274 186.274 240 120 240C53.7258 240 0 186.274 0 120C0 53.7258 53.7258 0 120 0ZM199.246 69.0684C196.895 62.3906 189.744 58.9457 183.277 61.374C132.101 80.589 75.8787 69.3175 54.7227 61.374C48.2552 58.9458 41.106 62.3907 38.7539 69.0684C36.4021 75.7466 39.7383 83.1292 46.2061 85.5576C56.8319 89.5474 74.5932 94.2 96.0664 96.4092C98.738 142.05 87.8278 182.406 81.0625 196.377C77.9848 202.733 80.4795 210.461 86.6348 213.639C92.7903 216.817 100.276 214.241 103.354 207.885C108.885 196.462 115.521 174.627 119 147.66C122.479 174.627 129.114 196.462 134.646 207.885C137.723 214.241 145.209 216.816 151.364 213.639C157.519 210.461 160.015 202.733 156.938 196.377C150.189 182.44 139.315 142.25 141.913 96.748C158.226 95.235 175.175 91.7974 191.794 85.5576C198.261 83.1292 201.599 75.7466 199.246 69.0684ZM119 22C106.956 22 97.1924 32.0811 97.1924 44.5166C97.1925 56.952 106.957 67.0332 119 67.0332C131.043 67.033 140.807 56.9518 140.807 44.5166C140.807 32.0813 131.043 22.0002 119 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUuIcon);
export default __webpack_public_path__ + "static/media/UU_icon.b171d3fec9eaf34df9cb763f17defbf9.svg";
export { ForwardRef as ReactComponent };